import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M5.833 8.335v-2.5a4.167 4.167 0 0 1 8.334 0v2.5m-3.334 5a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0m-6.666-5h11.666c.92 0 1.667.746 1.667 1.666v6.667c0 .92-.746 1.667-1.667 1.667H4.167c-.92 0-1.667-.747-1.667-1.667v-6.667c0-.92.746-1.666 1.667-1.666"
    }, null, -1)
  ]))]))
}
export default { render: render }